import { FormattedMessage, useIntl } from "react-intl";

import { PageLayout } from "../../common/page-layout/page-layout";

export const NotFound = () => {
  const intl = useIntl();

  return (
    <PageLayout title={intl.formatMessage({ id: "page.notfound.title" })}>
      <p>
        <FormattedMessage id="page.notfound.description" />
      </p>
    </PageLayout>
  );
};
